import axios from "axios";

export default class PolizasService {
  allPolizas() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "polizas/allactives");
  }
  allPolizasforadmin() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "polizas/all");
  }
  crearPoliza(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "polizas/create", data);
  }
  editarPoliza(data) {
    return axios.put(process.env.VUE_APP_API_PUBLIC + "polizas/update", data);
  }
  eliminarPoliza(data) {
    return axios.delete(process.env.VUE_APP_API_PUBLIC + "polizas/delete", {
      data: data,
    });
  }
  toggleActive(id) {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "polizas/activate/"+id);
  }
}
